<div class="header">
  <div class="title">Change Layout</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addProjectForm">
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>Which layout which you like to use?</mat-label>
    <mat-select [formControlName]="'template_id'">
      <mat-option value=""> -- Do not update -- </mat-option>
      <mat-option *ngFor="let projectTemplate of projectTemplates" [value]="projectTemplate.id">
        {{ projectTemplate.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="actions justify-end">
    <div class="buttons">
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        #btnFocus="matButton"
        [autofocus]="btnFocus.focus()"
        [disabled]="addProjectForm.pristine || addProjectForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!addProjectForm.disabled">Save</span>
        <mat-progress-spinner *ngIf="addProjectForm.disabled" [diameter]="24" [mode]="'indeterminate'">
        </mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
